import React__default from 'react';
import PropTypes__default from 'prop-types';
import { ListItem, ListItemIcon, ListItemText } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

var useStyles = makeStyles(function (theme) {
  return {
    listIcon: {
      minWidth: "unset",
      paddingRight: theme.spacing(2)
    }
  };
});
var PopupMenuItem = function PopupMenuItem(_ref) {
  var className = _ref.className,
    text = _ref.text,
    icon = _ref.icon,
    href = _ref.href,
    onMouseEnter = _ref.onMouseEnter,
    onMouseLeave = _ref.onMouseLeave,
    onClick = _ref.onClick;
  var classes = useStyles();
  var handleClick = function handleClick(event) {
    if (onClick) {
      onClick(event);
    }
  };
  var handleMouseEnter = function handleMouseEnter(event) {
    if (onMouseEnter) {
      onMouseEnter(event);
    }
  };
  var handleMouseLeave = function handleMouseLeave(event) {
    if (onMouseLeave) {
      onMouseLeave(event);
    }
  };
  return /*#__PURE__*/React__default.createElement(ListItem, {
    className: className,
    button: true,
    component: "a",
    href: href !== null && href !== void 0 ? href : undefined,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    onClick: handleClick
  }, icon && /*#__PURE__*/React__default.createElement(ListItemIcon, {
    className: classes.listIcon
  }, icon), /*#__PURE__*/React__default.createElement(ListItemText, {
    primary: text
  }));
};
PopupMenuItem.propTypes = {
  className: PropTypes__default.string,
  text: PropTypes__default.string.isRequired,
  icon: PropTypes__default.element,
  href: PropTypes__default.string,
  onMouseEnter: PropTypes__default.func,
  onMouseLeave: PropTypes__default.func,
  onClick: PropTypes__default.func
};

export { PopupMenuItem as default };
//# sourceMappingURL=PopupMenuItem.js.map
